// Loading — Phase G1 (P38-fix: palette-neutral splash).
//
// Originally a giant yellow pencil emoji on a purple→cream gradient.
// P38 recon showed that rendered for ~380ms of the cold-load window on
// /play and looked nothing like PathHome's cream/forest palette — the
// user perceived it as "old pencil / AdventureMap UI" flashing before
// PathHome appeared.
//
// Now delegates to <PathSplash>, a cream-background dot-pulse that
// matches PathHome's palette so the swap is invisible. Every call site
// (gate-ladder boot, Suspense fallback for lazy chunks, the
// OnboardingRedirector) inherits the new visual — no import churn.

import { PathSplash } from "../components/PathSplash";

export function Loading() {
  return <PathSplash testId="loading-splash" />;
}
